import dollarFormatter from './dollar_formatter'
import priceFormatter from './price_formatter'

const dollarPriceFormatter = (price) => dollarFormatter(priceFormatter(price))

export default dollarPriceFormatter
